<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">点位管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>点位人员管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="点位名称">
                <el-input
                  v-model="form.pointName"
                  clearable
                  placeholder="请输入点位名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="点位类型">
                <el-select
                  filterable
                  placeholder="点位类型"
                  clearable
                  v-model="form.pointType"
                >
                  <el-option
                    v-for="item in pointTypeOptions"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属社区">
                <el-select
                  filterable
                  placeholder="所属社区"
                  clearable
                  v-model="communityCode"
                  @change="commcommunityChange"
                >
                  <el-option
                    v-for="item in commcommunityList"
                    :key="item.code"
                    :label="item.pointName"
                    :value="item.id + '-' + item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属网格">
                <el-select
                  filterable
                  placeholder="所属网格"
                  clearable
                  v-model="form.blockCode"
                >
                  <el-option
                    v-for="item in blockList"
                    :key="item.code"
                    :label="item.pointName"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="所属单位类型">
                <el-select
                  filterable
                  placeholder="所属单位类型"
                  clearable
                  v-model="form.levelName3"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="人员姓名">
                <el-input
                  v-model="form.personName"
                  clearable
                  placeholder="人员姓名"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="人员所属单位">
                <el-input
                  v-model="form.personDeptName"
                  clearable
                  placeholder="人员所属单位"
                ></el-input>
              </el-form-item> -->
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div></div>
          <div class="right-btn">
            <el-button @click="addDialogFun('')" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="false"
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:pointTypes="{ scope }">
            <span>{{ getPointTypeName(scope.row.pointTypes) }}</span>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="delPointPersonByIdFun(scope.row.id)"
              style="color: #EB3538;font-size: 16px;"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      @refreshList="getPointPersonListPageFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import {
  getPointPersonListPage,
  updatePointType,
  delPointType,
  getCommcommunityAll,
  getblockAllByCommunityId,
  getPointTypeListPage,
  delPointPersonById
} from "@/api/point.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import index from "@/mixins/index.js";
export default {
  components: {
    addDialog,
    commonTable
  },
  mixins: [index],
  data() {
    return {
      form: {
        pointName: "",
        pointType: "",
        communityCode: "",
        blockCode: "",
        personName: "",
        personDeptName: ""
      },
      options: [],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            slot: "pointTypes",
            label: "点位类型"
          },
          {
            prop: "pointName",
            label: "点位名称"
          },
          {
            prop: "levelName2",
            label: "所属社区"
          },
          {
            prop: "levelName3",
            label: "所属网格"
          },

          {
            prop: "personName",
            label: "人员姓名"
          },
          {
            prop: "personPhone",
            label: "手机号"
          },
          {
            prop: "personDeptName",
            label: "人员所属单位"
          },
          {
            prop: "personDeptName",
            label: "所属单位类型"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      curItem: {}
    };
  },
  mounted() {
    this.getCommcommunityAllFun();
    this.getPointTypeListPageFun();
    this.getPointPersonListPageFun();
  },
  methods: {
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointPersonListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointPersonListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointPersonListPageFun();
    },
    onReset() {
      this.form.pointName = "";
      this.form.pointType = "";
      this.form.communityCode = "";
      this.communityCode = "";
      this.form.blockCode = "";
      this.form.personName = "";
      this.form.personDeptName = "";
      this.page.page = 1;
      this.page.size = 10;
      this.getPointPersonListPageFun();
    },
    // 删除
    async delPointPersonByIdFun(id) {
      let params = {
        id: id
      };
      const res = await delPointPersonById(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.getPointPersonListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },

    // 分页查询
    async getPointPersonListPageFun() {
      let params = {
        pointName: this.form.pointName,
        pointType: this.form.pointType,
        blockCode: this.form.blockCode,
        communityCode: this.form.communityCode,
        personName: this.form.personName,
        personDeptName: this.form.personDeptName,
        page: this.page.page,
        size: this.page.size
      };
      const res = await getPointPersonListPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointPerson/index.vue